import styled from 'styled-components';
import { media, rem, themed } from '../../core';

export const Container = styled.div.attrs({
  className: 'ImpersonationBanner',
})`
  align-items: center;
  background-color: ${themed('status.warning.light')};
  color: ${themed('status.warning.main')};
  display: flex;
  font-size: ${rem(14)};
  height: 5rem;
  justify-content: center;
  line-height: 1.35;
  padding: 1rem;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 2;

  @media ${media.desktopMin} {
    height: ${rem(44)};
    line-height: ${rem(44)};
    padding: 0 1rem;
    position: initial;
  }

  a {
    color: inherit;
    font-weight: bold;
    text-decoration: none;
  }

  button {
    cursor: pointer;
    display: inline;
    width: auto;
  }
`;
